import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthProvider } from 'authorization/providers/auth/auth-provider';
import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { RewardsBusiness } from 'rewards/models/rewards-business';

/**
 * authentication guard preventing user from accessing page if not logged in
 */
@Injectable()
export class RewardsBusisnessGuard 
{
    /**
    * Class constructor
    * @param router
    * @param auth
    */
    constructor
        (
            private router: Router,
            private auth: AuthProvider
        )
    {
    }

    /**
     * CanActivate method implementation, returning true if the page can
     * be accessed or a URL tree if a redirection has to be done.
     * Will return true only if the reward business is provided among the
     * query parameters
     * @param next
     * @param state
     */
    async canActivate(route: ActivatedRouteSnapshot)
    {
        let business: RewardsBusiness = route.queryParams.business;
        if (business)
        {
            return true;
        } else
        {
            let sessionToken = (await this.auth.getUserIdentity()).sessionToken
            return this.router.parseUrl('/home/' + sessionToken);
        }
    }
}